import React, { useState } from 'react';
import { Row, Col, Button, Spinner } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComments, faUser, faTrash } from '@fortawesome/free-solid-svg-icons';
import BZAPIService from '../../services/BZAPIService';
import PropTypes from 'prop-types';
import moment from 'moment';

const Comments = ({
  projectId,
  versionId,
  productName,
  productId,
  fetchUserVersionState,
  selectedVersion,
  userVersionData
}) => {
  const [comment, setComment] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showComments, setShowComments] = useState(true);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleChange = event => {
    setComment(event.target.value);
  };

  const handleAddComment = async () => {
    if (!comment) return;
    setIsLoading(true);
    await BZAPIService.bsaCreateVersionComment({
      projectId,
      versionId,
      text: comment,
      productName,
      productId
    });
    await fetchUserVersionState(selectedVersion);
    setComment('');
    setIsLoading(false);
  };

  const handleDeleteComment = async commentId => {
    setIsDeleting(commentId);
    console.log('commentId x ver', commentId, userVersionData);
    await BZAPIService.bsaDeleteVersionComment({
      projectVersionId: userVersionData.id,
      commentId
    });
    await fetchUserVersionState(selectedVersion);
    setIsDeleting(false);
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleAddComment();
    }
  };

  return (
    <>
      <Row className="mt-4">
        <Col md="12">
          <h6
            className="my-4"
            style={{ fontSize: '1.25rem', cursor: 'pointer' }}
            onClick={() => setShowComments(!showComments)}
          >
            <FontAwesomeIcon icon={faComments} className="me-2" />
            {userVersionData?.comments?.length || 0} Comments (
            <button
              style={{ textDecoration: 'underline', background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
            >
              {showComments ? 'Hide' : 'Show'}
            </button>
            )
          </h6>
        </Col>
        <Col md="12">
          {showComments && userVersionData?.comments?.length > 0 && (
            <ul className="list-group">
              {userVersionData?.comments.map((comment, index) => (
                <li key={index} className="list-group-item">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <FontAwesomeIcon icon={faUser} className="me-2" />
                      <strong>{comment.userId}</strong>
                      <span className="ms-2 text-muted">{moment.utc(comment.timestamp).fromNow()}</span>
                    </div>
                    <Button color="danger" size="sm" onClick={() => handleDeleteComment(comment.id)}>
                      {isDeleting === comment.id ? <Spinner size="sm" /> : <FontAwesomeIcon icon={faTrash} />}
                    </Button>
                  </div>
                  <div style={{ whiteSpace: 'pre-wrap' }}>{comment.text}</div>
                </li>
              ))}
            </ul>
          )}
        </Col>
      </Row>
      {showComments && (
        <Row className="mt-4">
          <Col md="12">
            <textarea
              className="form-control mt-4"
              rows="3"
              placeholder="Add a comment"
              value={comment}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
            />
          </Col>
          <Col md="12" className="text-end mt-3">
            <Button
              className="btn btn-falcon-default btn-sm"
              disabled={!comment || isLoading}
              onClick={handleAddComment}
            >
              {isLoading ? <Spinner size="sm" /> : 'Add comment'}
            </Button>
          </Col>
        </Row>
      )}
    </>
  );
};

Comments.propTypes = {
  projectId: PropTypes.string.isRequired,
  versionId: PropTypes.string.isRequired,
  productName: PropTypes.string.isRequired,
  productId: PropTypes.string.isRequired,
  fetchUserVersionState: PropTypes.func.isRequired,
  selectedVersion: PropTypes.object,
  comments: PropTypes.arrayOf(PropTypes.string),
  setUserVersionData: PropTypes.func.isRequired,
  userVersionData: PropTypes.object
};

export default Comments;
